import { defineStore } from "pinia";
import { isNetworkUnavailable } from "@/composables/network/offlineMode";
import { analysisResultRestClient } from "@/api";
import db from "@/db";
import crudGenerator from "@/api/utils/offlineSync";
import { useProjectsStore } from "@/store/modules/projects";

const { innerCreate, innerUpdate } = crudGenerator(db.models.AnalysisResult);

export const useAnalysisResultStore = defineStore("analysisResult", {
  state: () => ({
    analysisResultIsLoading: false,
    analysisResultList: [],
  }),
  actions: {
    async fetchAnalysisResult(projectUuid) {
      if (isNetworkUnavailable()) return;
      this.analysisResultIsLoading = true;
      const response = await analysisResultRestClient.listAll({
        project: projectUuid,
      });
      await db.transaction("rw", db.analysisResult, async () => {
        for (const analysisResultResponse of response.results) {
          db.models.AnalysisResult.createOrUpdate(analysisResultResponse);
        }
      });
      this.analysisResultIsLoading = false;
      return response.results;
    },

    async setAnalysisResult(sampleFlaskUuid) {
      this.analysisResultList = await db.analysisResult
        .where("sampleFlask")
        .anyOf(sampleFlaskUuid)
        .toArray();
    },

    async createAnalysisResult(form) {
      this.analysisResultIsLoading = true;
      const analysisResult = await innerCreate(
        form,
        useProjectsStore().isOfflineState
      );
      this.analysisResultList.push(analysisResult);
      this.analysisResultIsLoading = false;
    },

    async updateAnalysisResult(form) {
      this.analysisResultIsLoading = true;
      const analysisResult = await innerUpdate(
        form,
        useProjectsStore().isOfflineState
      );
      const index = this.analysisResultList.findIndex(
        ({ uuid }) => analysisResult.uuid === uuid
      );
      if (index >= 0) {
        this.analysisResultList[index] = analysisResult;
        this.analysisResultList = [...this.analysisResultList];
      }
      this.analysisResultIsLoading = false;
    },
  },
});
